import React from "react";
import Image from "next/image";
import buttonHelper from "./../helpers/buttonHelper";
import { getImageURL } from "@/helpers/imageURLHelper";

const CardItem = ({
  buttonPage,
  buttonPage2,
  buttonText,
  buttonText2,
  target,
  target2,
  date,
  fromPage,
  page,
  news,
  course,
  concert,
  image,
  menu,
  shortText,
  title,
  url,
  url2,
}) => {
  const isConcert = !!fromPage && !!fromPage?.SpektrixID;
  let cardDate = !!date
    ? date
    : !!fromPage?.Date && !!fromPage?.Time
      ? `${fromPage?.Date} ${fromPage?.Time}`
      : null;

  cardDate = cardDate?.includes(" ")
    ? cardDate.replace(" ", "T") + "Z"
    : cardDate;

  const draftDate = new Date(cardDate).toLocaleString("en-US", {
    timeZone: date ? "America/Toronto" : "UTC",
    dateStyle: "medium",
    timeStyle: "short",
    hour12: true,
  });

  const datetime = draftDate.split(", ");
  const formattedDate =
    datetime[0] +
    ", " +
    datetime[1] +
    (!!fromPage?.Time
      ? " " + datetime[2]
      : datetime[2] != "Invalid Date" &&
          datetime[2] != undefined &&
          datetime[2] != "12:00 AM"
        ? " " + datetime[2]
        : "");

  const buttonPageUrl = buttonPage
    ? buttonHelper.findSlugPath(menu, buttonPage?.title)
    : null;
  const buttonPageUrl2 = buttonPage2
    ? buttonHelper.findSlugPath(menu, buttonPage2?.title)
    : null;

  const selfLinkUrl = fromPage?.cardInfo?.selfLink?.link;
  const selfLinkTitle =
    fromPage?.cardInfo?.selfLinkButtonName ||
    fromPage?.cardInfo?.selfLink?.title;
  const externalLinkUrl =
    fromPage?.cardInfo?.externalLink?.link ||
    (isConcert && "/tickets/seats/" + fromPage?.SpektrixID);
  const externalLinkTitle = fromPage?.cardInfo?.externalLink?.title;

  const selfButtonText = buttonText
    ? buttonText
    : selfLinkTitle || (isConcert && "View More");
  const externalButtonText =
    buttonText2 ||
    externalLinkTitle ||
    (isConcert &&
      !!fromPage?.SpektrixID &&
      !!fromPage?.BuyTicketsButtonLabel &&
      fromPage?.BuyTicketsButtonLabel);

  const cardFullSelfUrl = buttonHelper.getLink(
    {
      page: page ?? null,
      news: news ?? null,
      course: course ?? null,
      concert: concert ?? null,
    },
    menu
  );

  const linkUrl = url || buttonPageUrl || selfLinkUrl || cardFullSelfUrl;
  const linkUrl2 = url2 || buttonPageUrl2 || externalLinkUrl;
  const cardTitle = fromPage?.cardInfo?.title || title; // cardInfo.title is will be overriding the title here
  const cardText =
    shortText || (isConcert ? "" : fromPage?.cardInfo?.description) || "";

  const cardImage =
    image ||
    fromPage?.cardInfo?.image?.data?.attributes ||
    fromPage?.EventImage?.data?.attributes;

  return (
    <div
      className={
        "tps-card-item cell" +
        (selfButtonText && externalButtonText ? " tps-card-item-2-buttons" : "")
      }
    >
      {cardImage && (
        <a
          className={"tps-card-item-image lazyloaded"}
          href={linkUrl || "#"}
          target={target}
          rel={target === "_blank" ? "noopener noreferrer" : undefined}
          aria-hidden="true"
          tabIndex="-1"
        >
          <Image
            src={getImageURL(cardImage?.url)}
            alt={cardImage.alternativeText || ""}
            quality={88}
            fill={true}
            style={{ objectFit: "cover", objectPosition: "top" }}
            placeholder="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM88x8AAp0BzdNtlUkAAAAASUVORK5CYII="
            loading="lazy"
            sizes="(max-width: 400px) 100vw, (max-width: 520px) 50vw, (max-width: 1024px) 25vw, 25vw"
          />
        </a>
      )}

      <div className={"tps-card-item-inner"}>
        {cardDate && (
          <div className="tps-card-item-date">
            <div
              className="tps-card-item-date-inner"
              data-utc-date={JSON.stringify(cardDate)}
            >
              {formattedDate}
              <br />
            </div>
          </div>
        )}
        {cardTitle && (
          <a
            className={"tps-card-item-title h4 separator-left"}
            href={linkUrl || "#"}
            target={target}
            rel={target === "_blank" ? "noopener noreferrer" : undefined}
          >
            {cardTitle}
          </a>
        )}

        <div
          className={"tps-card-item-text"}
          dangerouslySetInnerHTML={{ __html: cardText }}
        ></div>
        <div className={"tps-card-item-actions"}>
          {selfButtonText && (
            <a
              className={"tps-card-item-action button"}
              aria-hidden="true"
              tabIndex="-1"
              href={linkUrl || "#"}
              target={target}
              rel={target === "_blank" ? "noopener noreferrer" : undefined}
            >
              {selfButtonText}
            </a>
          )}
          {externalButtonText && (
            <a
              className={
                "tps-card-item-action tps-card-item-action-info button"
              }
              aria-hidden="true"
              tabIndex="-1"
              href={linkUrl2 || "#"}
              target={target2}
              rel={target2 === "_blank" ? "noopener noreferrer" : undefined}
            >
              {externalButtonText}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardItem;
